import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ContactService } from 'src/app/rest_services/contact.service';
import { CustomersService } from 'src/app/rest_services/customers.service';

@Component({
  selector: 'app-new-contact',
  templateUrl: './new-contact.component.html',
  styleUrls: ['./new-contact.component.css']
})
export class NewContactComponent implements OnInit {

  newContactForm!:FormGroup;
  loadingAddingContact:boolean = false;
  addError:any;
  owner:any;
  constructor(
    private formBuilder: FormBuilder,
    private contactService: ContactService,
    private router : Router, 
    private customersService :CustomersService) { }

  ngOnInit(): void {
    if(localStorage.getItem("fullname")!=undefined) {
      this.owner =localStorage.getItem("fullname");
    }else if(sessionStorage.getItem("fullname")!=undefined){
      this.owner =sessionStorage.getItem("fullname");
    }
    this.newContactForm = this.formBuilder.group({
      'owner': [this.owner],
      'nomCompte': [''],
      'civilite': ['', Validators.required],
      'prenom': ['', Validators.required],
      'nom': ['', Validators.required],
      'telephoneDomicile': ['', Validators.pattern(/^\d{10}$/)],
      'telephoneMobile': ['',[Validators.pattern(/^\d{10}$/), Validators.required]],
      'telephoneAutre': ['', Validators.pattern(/^\d{10}$/)],
      'serviceContact': [''],
      'fonctionContact': [''],
      'email': ['', [Validators.required, Validators.email]],
      'responsableHierarchique': [''],
      'originePiste': [''],
      'langue': [''],
      'adresseRue': [''],
      'codePostal': [''],
      'ville': [''],
      'pays': [''],
      'autreAdresseRue': [''],
      'autreCodePostal': [''],
      'autreVille': [''],
      'autrePays': [''],
      'quitterSociete': [false],
      'invalideContact': [false],
      'garderContact': [true],
      'description': ['']
    });
    this.getAllCustomers();
  }
  saveAndReset() {
    this.saveContact(() => {
      this.addedMsg= 'Veuillez ajouter un autre contact';
      this.resetForm();
    });
  }

  save() {
    this.saveContact(() => {
      setTimeout(()=>{
        this.router.navigate(['/contacts']);
      }, 2000);
    });
  }
  addedMsg:any ='';
  saveContact(callback: () => void){
    $("html, body").animate({ scrollTop: 0 });
    this.loadingAddingContact = true;
    if (this.newContactForm.valid) {
      const contactData = this.newContactForm.value;
      contactData.owner = this.owner;
      this.contactService.createNewContact(contactData);
      this.contactService.newContactSubject.subscribe((response) => {
        this.loadingAddingContact = false;
        if (response.code == "755ca336b457df88116abecffe826179") {
          $("#contact_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_added").hide();
          }, 2000);
          callback();
        } else if(response.code == "8ba87ea066c073a04dcaf677b1135e0f")  {
          this.addError ="Contact existe dèja"; 
          $("#contact_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_not_added").hide();
          }, 3000);
        } else if (response.code == "fb20be5e711acc676f68cd0e484e84a9") {
          this.addError =". Données invalides pour la création du contact"; 
          $("#contact_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_not_added").hide();
          }, 3000);
        }
      },
      (error) => {
        console.log('Contact creation error:', error);
        this.addError =". Contact non ajouté"; 
          $("#contact_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_not_added").hide();
          }, 3000);
      });
    } else {
    }
  }

  refClients:any[] =[];
  getAllCustomers(){
    var glob=this;
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        if(data.code=="a12d89f623abb138ebacc91b3703326a" && data.customers !=null){
          var newArrayAllCustomers:any[] = [];
          for(let cust of data.customers){
            var sites:any[]=[];
            var site:any = {
              city:cust.customer_city,
              uuid:cust.city,
              customer:cust.customer
            }
            sites.push(site)
            var customer = {
              rs_customer:cust.customer_rs,
              city_uuid:cust.customer_city,
              uuid:cust.customer,
              sites:sites
            }
            newArrayAllCustomers.push(customer);
          }
          setTimeout(()=>{
            this.refClients = newArrayAllCustomers;
            (<any>$( "#nomCompte" )).autocomplete({
              source: function ( request:any, response:any ) {
                response($.map(glob.refClients, function (obj, key) {
                  var name = obj.rs_customer.toUpperCase();
                  if (name.indexOf(request.term.toUpperCase()) != -1) {				
                    return {
                      label: obj.rs_customer,
                      value: obj.rs_customer // Value
                    }
                  } else {
                    return null;
                  }
                }));			
              },    
              focus: function(event:any, ui:any) {
                event.preventDefault();
              },
              // Once a value in the drop down list is selected, do the following:
              select: function(event:any, ui:any) {
                      event.preventDefault();
                // place the person.given_name value into the textfield called 'select_origin'...
                glob.newContactForm.controls['nomCompte'].setValue(ui.item.value);             
                $('#nomCompte').val(ui.item.label);
                // ... any other tasks (like setting Hidden Fields) go here...
              }
            });
          }, 1000);
        }
        
      },
    )  
  }
  
  resetForm() {
    this.newContactForm.reset();
  }

}
